<template>
  <div class="edit-notice-container">
    <div class="page-content">
      <div class="page-title">{{ $t('editNoticeView.title') }}</div>
      <el-form ref="form" :model="editNoticeViewInfo" :rules="rules" label-width="120px">
        <el-form-item :label="$t('editNoticeView.communityLabel')" prop="communityIds">
          <el-select
            v-model="editNoticeViewInfo.communityIds"
            multiple
            filterable
            collapse-tags
            :placeholder="$t('editNoticeView.communityPlaceholder')"
            style="width:100%"
          >
            <el-option v-for="item in communitys" :key="item.communityId" :label="item.name" :value="item.communityId" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('editNoticeView.titleLabel')" prop="title">
          <el-input v-model="editNoticeViewInfo.title" :placeholder="$t('editNoticeView.titlePlaceholder')" clearable />
        </el-form-item>
        <el-form-item :label="$t('editNoticeView.noticeTypeLabel')" prop="noticeTypeCd">
          <el-select v-model="editNoticeViewInfo.noticeTypeCd" :placeholder="$t('editNoticeView.noticeTypePlaceholder')" style="width:100%">
            <el-option :label="$t('editNoticeView.noticeTypeOption1')" value="1000" />
            <el-option :label="$t('editNoticeView.noticeTypeOption2')" value="1001" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('editNoticeView.contentLabel')" prop="context">
          <div class="editor-wrapper">
            <rich-text-editor ref="richTextEditor" v-model="editNoticeViewInfo.context" :placeholder="$t('editNoticeView.contentPlaceholder')" />
          </div>
        </el-form-item>
        <div class="button-group">
          <el-button class="cancel-btn" @click="closeEditNoticeInfo">
            {{ $t('common.cancel') }}
          </el-button>
          <el-button class="submit-btn" type="primary" @click="editNotice">
            {{ $t('common.submit') }}
          </el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { updateNotice, getNoticeDetail } from '@/api/oa/editNoticeViewApi'
import { getEffectiveCommunityId, getMyEnteredCommunitys } from '@/api/community/communityApi'
import RichTextEditor from "@/components/editor/RichTextEditor";


export default {
  name: 'EditNoticeViewList',
  data() {
    return {
      editNoticeViewInfo: {
        noticeId: '',
        title: '',
        noticeTypeCd: '',
        context: '',
        startTime: '',
        endTime: '',
        communityId: '',
        communityIds: []
      },
      communitys: [],
      rules: {
        noticeId: [
          { required: true, message: this.$t('editNoticeView.validate.noticeIdRequired'), trigger: 'blur' }
        ],
        communityIds: [
          { type: 'array', required: true, message: this.$t('editNoticeView.validate.communityRequired'), trigger: 'change' }
        ],
        title: [
          { required: true, message: this.$t('editNoticeView.validate.titleRequired'), trigger: 'blur' },
          { max: 200, message: this.$t('editNoticeView.validate.titleMaxLength'), trigger: 'blur' }
        ],
        noticeTypeCd: [
          { required: true, message: this.$t('editNoticeView.validate.noticeTypeRequired'), trigger: 'change' }
        ],
        context: [
          { required: true, message: this.$t('editNoticeView.validate.contentRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  components: {
    RichTextEditor
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      this.editNoticeViewInfo.noticeId = this.$route.query.noticeId
      const communityId = getEffectiveCommunityId()
      this.editNoticeViewInfo.communityId = communityId
      this.editNoticeViewInfo.communityIds = communityId ? [communityId] : []
      this.loadCommunitys()
      await this._initEditNoticeInfo()
    },
    async loadCommunitys() {
      try {
        const res = await getMyEnteredCommunitys({ page: 1, row: 1000 })
        this.communitys = (res.communitys || []).filter(item => getEffectiveCommunityId(item.communityId))
      } catch (error) {
        this.$message.error(this.$t('editNoticeView.fetchCommunityError'))
      }
    },
    async _initEditNoticeInfo() {
      try {
        const params = {
          page: 1,
          row: 1,
          noticeId: this.editNoticeViewInfo.noticeId
        }
        const { notices } = await getNoticeDetail(params)
        const communityId = getEffectiveCommunityId(notices[0].communityId)
        this.editNoticeViewInfo = { ...notices[0], communityIds: communityId ? [communityId] : [] }
        this.$refs.richTextEditor.setContent(notices[0].context)

      } catch (error) {
        this.$message.error(this.$t('editNoticeView.fetchError'))
      }
    },
    editNoticeValidate() {
      if (this.editNoticeViewInfo.communityIds.length !== 1) {
        this.$message.warning(this.$t('editNoticeView.validate.communityOnlyOne'))
        return false
      }
      return true
    },
    async editNotice() {
      this.$refs.form.validate(async valid => {
        if (!valid || !this.editNoticeValidate()) {
          return
        }
        try {
          const { code, msg } = await updateNotice({
            ...this.editNoticeViewInfo,
            communityId: getEffectiveCommunityId(this.editNoticeViewInfo.communityIds[0])
          })
          if (code === 0) {
            this.$message.success(this.$t('common.operationSuccess'))
            this.closeEditNoticeInfo()
          } else {
            this.$message.error(msg)
          }
        } catch (error) {
          this.$message.error(this.$t('editNoticeView.updateError'))
        }
      })
    },
    closeEditNoticeInfo() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-notice-container {
  padding: 20px;
  background-color: #EBF2FA;
  min-height: calc(100vh - 84px);
  font-family: 'PingFang SC', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;

  .page-content {
    background: #FFFFFF;
    border-radius: 12px;
    padding: 24px;
  }

  .page-title {
    color: #1D2129;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  ::v-deep .el-form-item__label {
    color: #1D2129;
    font-size: 14px;
    font-weight: 500;
  }

  ::v-deep .el-input__inner {
    border-radius: 10px;
    border: 1px solid #DCE6F5;
    height: 38px;
    line-height: 38px;
  }

  ::v-deep .el-select .el-input__inner {
    border-radius: 10px;
  }

  ::v-deep .el-input__inner:focus {
    border-color: #0E76FF;
  }

  .editor-wrapper {
    width: 100%;
  }

  .button-group {
    text-align: right;
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }

  .cancel-btn {
    width: 98px;
    height: 38px;
    border-radius: 10px;
    border: 1px solid #0E76FF;
    color: #0E76FF;
    background: #FFFFFF;
  }

  .submit-btn {
    width: 98px;
    height: 38px;
    border-radius: 10px;
    border: none;
    background: #0E76FF;
  }
}
</style>
